module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgments"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("I am grateful to those who have read my previous work and encouraged me to continue writing.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("I also wish to thank Kate Yates, née Babcock, a friend of my youth and ever since, for permission to use her watercolour image on the cover.")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _c('p', {
    staticStyle: {
      "padding-top": "150px",
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("\"When I was young, all lives but mine")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Were windows in a house of stone")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("From which interior light did shine")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("On me, outside, alone.\"")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Charles Morgan")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ee3483c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0